import { useEffect, useState } from "react";
import { getByRegistroReferencia, putOne } from "../../../../database/dbRegistroGeneral";
import { Avatar, Box, Button, Container, createTheme, CssBaseline, Divider, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField, ThemeProvider, Typography } from "@mui/material";
import { CustomDialog } from "../../../modules/dialogs/CustomDialog";
import { SelectCustom } from "../../../modules/ui/SelectCustom";
import { FileUploadCustom } from "../../../modules/ui/FileUploadCustom";
import { logObject } from "../../../../utils/validations";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { format } from "date-fns";
import { useFetchFacturaCats } from "../../../../hooks/useFetchFacturaCats";
import moment from "moment";
import { renderToString } from "react-dom/server";
import { setBodyPaymentReceived } from "../emails/bodies";
import { sendEmail } from "../../../../services/sendEmail";


const eventLogo = "https://eventos.cibnor.mx/intranet/img/logo_sina2025.png";


const INITIAL_STATE = {
    comprobanteURL: '',     // URL resultante de la carga del archivo
    requiereFactura: '',    // Control interno, Si o No, para validaciones
    aNombreDe: '',          // Nombre a facturar
    concepto: '',           // Concepto para el patrocinador
    constanciaURL: '',      // URL resultante de la carga del archivo
    correo: '',             // Correo electronico a donde se enviara la factura
    facturaTipo: '',        // Control interno, 'Nacional' o 'Extranjero', para validaciones
    personaTipo: '',        // Control interno, Fisica o Moral, para validaciones
    RFC: '',                // Dato contribuyente nacional
    CP: '',                 // Dato contribuyente nacional
    UsoCFDI: '',            // Dato contribuyente nacional
    RegimenFiscal: '',      // Dato contribuyente nacional
    formato32DURL: '',      // Dato contribuyente nacional persona moral
    updatedAt: moment().format('YYYY-MM-DDTHH:mm:ss'),
}


export const Sina2025ConfirmarPago = () => {

    // const queryParameters = new URLSearchParams(window.location.search);
    // const referencia = queryParameters.get('referencia');

    const { referencia } = useParams();

    const [isDataLoaded, setisDataLoaded] = useState(false);
    const [isWaiting, setIsWaiting] = useState(false);
    const [record, setRecord] = useState({});

    const [uploadingFile, setUploadingFile] = useState(false);

    // const [isInvoiceRequired, setIsInvoiceRequired] = useState('');
    const [invoiceData, setInvoiceData] = useState(INITIAL_STATE);


    const { dataCDFIs, dataRFs, loading } = useFetchFacturaCats();


    const handleInputChange = ({ target }) => {
        const { name, value } = target;
        // console.log({ name, value });

        setInvoiceData({ ...invoiceData, [name]: value });
    }

    const handleCatalogChange = ({ target }) => {
        console.log({target});
        const { value, name } = target;

        let item = {};
        switch (name) {
            case 'UsoCFDI':
                item = dataCDFIs.find(i => i.value === value);
                setInvoiceData({ ...invoiceData, [name]: item.label });
                break;
            case 'RegimenFiscal':
                item = dataRFs.find(i => i.value === value);
                setInvoiceData({ ...invoiceData, [name]: item.label });
                break;
        
            default:
                break;
        }
    }

    const handleFileUploaded = ({exito, mensaje, data }, param) => {
        console.log({exito, mensaje, data }, param);
        //* En caso de error, notifica
        if (!exito) {
            Swal.fire({
                title: 'Error', 
                text: 'Falló la carga del archivo / Upload file failed', 
                icon: 'error',
                footer: 'Por favor, reporte la situación / Please, report',
                showConfirmButton: false,
                allowEscapeKey: false,
                allowOutsideClick: false,
            })
            return;
        }

        setInvoiceData({ ...invoiceData, [param]: `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ data }`, })
    }

    // Al hacer click en el boton 'enviar'
    const onSubmitInvoiceData = async(event) => {
        event.preventDefault();
        console.log({ record });
        
        //* Validamos el formulario

        // Comprobante cargado
        if (invoiceData.comprobanteURL === '') {
            Swal.fire({ icon: 'error', text: `"Comprobante de pago / Proof of payment" vacio / empty.` });
            return;
        }
        //Solicita factura
        if (invoiceData.requiereFactura === '') {
            Swal.fire({ icon: 'error', text: `"¿Requiere factura? / Invoice?" vacio / empty.` });
            return;
        }

        // Si requere factura
        if (invoiceData.requiereFactura === 'Si') {

            if (invoiceData.aNombreDe === '') {
                Swal.fire({ icon: 'error', text: `"Factura a nombre de / Invoice to" vacio / empty.` });
                return;
            }
            if (invoiceData.correo === '') {
                Swal.fire({ icon: 'error', text: `"Correo electrónico / Email" vacio / empty.` });
                return;
            }
            
            // Si requiere factura y es nacional
            if (invoiceData.facturaTipo === 'Nacional') {
                // Constancia de Situación Fiscal
                if (invoiceData.constanciaURL === '') {
                    Swal.fire({ icon: 'error', text: `"Constancia de Situación Fiscal" pendiente.` });
                    return;
                }
                // RFC
                if (invoiceData.RFC === '') {
                    Swal.fire({ icon: 'error', text: `"RFC" vacio.` });
                    return;
                }
                // CP
                if (invoiceData.CP === '') {
                    Swal.fire({ icon: 'error', text: `"CP" vacio.` });
                    return;
                }
                // CFDI
                if (invoiceData.UsoCFDI === '') {
                    Swal.fire({ icon: 'error', text: `"Uso CFDI" vacio.` });
                    return;
                }
                // Regimen
                if (invoiceData.RegimenFiscal === '') {
                    Swal.fire({ icon: 'error', text: `"Régimen Fiscal" vacio.` });
                    return;
                }
                
            }

        }

        setIsWaiting(true);

        //* Armamos el objeto de infoAdicional con lo nuevo
        let infoAdicionalTmp = JSON.parse( JSON.stringify(record.infoAdicional) );
        infoAdicionalTmp.datosFactura = invoiceData;
        console.log({ infoAdicionalTmp });
        
        const recordToUpdate = { ...record, infoAdicional: JSON.stringify(infoAdicionalTmp) };
        console.log({ recordToUpdate });

        //* Guardar en la base de datos y notificar
        // Se actualiza el registro
        const { exito } = await putOne(record.id, recordToUpdate);

        // Hubo un error
        if (!exito) {
            setIsWaiting(true);
            Swal.fire('¡Error!', 'Presione Ok, tome una captura de pantalla y notifique. / Press Ok, take a screenshot and notify.', 'error')
            return;
        }


        const datosRegistro = {
            tituloEvento: 'Simposio Internacional en Nutrición Acuícola',
            correoEvento: 'sina2025@cibnor.mx',
            urlLogo: eventLogo,
            modalidad: record.infoAdicional.modalidad
        }

        const recordTmp = { ...record, infoAdicional: infoAdicionalTmp };
        const msgbody = renderToString( 
            setBodyPaymentReceived({ 
                datosParticipante: recordTmp, 
                datosRegistro, 
            })
        );

        const emailObj = {
            "toemail": record.partCorreo,
            "subject": `Comprobante de pago | ${ datosRegistro.tituloEvento }`,
            "message": msgbody,
            "replyto": datosRegistro.correoEvento,
            "tocc": process.env.REACT_APP_TOBCC_FACTURACION !== '' ? datosRegistro.correoEvento : '',
            "tobcc": 'eventos.cibnor@cibnor.mx',
        };

        const emailResult = await sendEmail(emailObj);
        console.log(emailResult);

        setIsWaiting(false);

        Swal.fire({
            title: 'Información enviada / Info sended',
            text: 'Consulte su correo para mayor información / Check your email for more information.',
            icon: 'success',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
        })
    };


    //* Se recupera y formatea la data
    useEffect(async() => {

        const { data } = await getByRegistroReferencia(referencia);
        const recordTmp = data[0];

        const infoAdicional = JSON.parse(recordTmp.infoAdicional);
        const recordToShow = { ...recordTmp, infoAdicional: infoAdicional };

        const { datosFactura } = infoAdicional;
        console.log({datosFactura});

        if (datosFactura) {
            Swal.fire({
                title: 'Comprobante ya entregado / Proof of payment delivered',
                icon: 'info',
                text: `Fecha / Date: ${ datosFactura 
                    ? `${ moment(datosFactura.updatedAt).format('YYYY-MM-DD, HH:mm') } hrs.`
                    : 'Pendiente' }`,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
              });
        }

        console.log(recordToShow)
        setRecord(recordToShow);

        setisDataLoaded(true);
    }, [ referencia ])


    return (
        <ThemeProvider theme={createTheme()}>
        <CustomDialog title='Cargando archivo...' show={ uploadingFile } />
        <CustomDialog title='Por favor espere / Please wait' show={ !isDataLoaded } />
        {
            isDataLoaded &&
            <Container component="main">
            <CssBaseline />
                
                <CustomDialog title='Por favor espere / Please wait' show={ isWaiting } />

                <Box m={ 2 } display='flex' flexDirection='row' alignItems='center'>
                    <Avatar src='https://aena.mx/images/nicepage-images/80f8a68a08b4341bcc455d466709dc31.png' sx={{ width: 100, height: 'auto', px: 2 }} />
                    <Box>
                        <Typography fontSize={ 20 } fontWeight={ 900 }>Simposio Internacional en Nutrición Acuícola</Typography>
                        <Typography fontSize={ 20 }>Comprobación de pago</Typography>
                    </Box>
                </Box>
                    <form onSubmit={ onSubmitInvoiceData } noValidate>
                        <Paper elevation={ 4 } sx={{ m: 2, p: 2 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={ 6 }>
                                    <Typography fontSize={ 24 } fontWeight={ 900 }>
                                        { `${ record.partApellidoPaterno } ${ record.partApellidoMaterno } ${ record.partNombres }` }
                                    </Typography>
                                    <Typography color='blue'>{ record.partCorreo }</Typography>
                                    <Typography>{ referencia }</Typography>
                                    <Typography fontWeight={ 900 }>{ record.tipoRegistro }</Typography>
                                </Grid>
                                <Grid item xs={ 6 }>
                                    <Typography color='blue'>Comprobante de pago / Proof of payment</Typography>
                                    <FileUploadCustom 
                                        helperText='Anexar archivo en formato PDF / Add file in PDF format'
                                        //* Ejecuta 'handleFileUploaded' con el resultado del upload y el id del control
                                        parentCallback={ (e) => handleFileUploaded(e, 'comprobanteURL') }
                                        //* Muestra el waiting dialog en lo se realiza el upload
                                        parentWaitingCallback={ (val) => setUploadingFile(val) }
                                        saveFileAs= { `${ referencia }_comprobante` }
                                        validTypes ={ ['pdf'] }
                                        variant='standard'
                                    />
                                </Grid>
                                <Grid item xs={ 12 }><Divider /></Grid>

                                <Grid item xs={ 6 }>
                                    <SelectCustom 
                                        label='¿Requiere factura? / Invoice?'
                                        name='requiereFactura'
                                        options={ [
                                            { value: 'Si', label: 'Si' },
                                            { value: 'No', label: 'No' },
                                        ] }
                                        parentCallback={ handleInputChange }
                                        value={ invoiceData.requiereFactura }
                                        variant='standard'
                                    />
                                </Grid>
                            </Grid>
                            
                            {/* 
                            //* Si el usuario requiere factura 
                            */}
                            <Grid 
                                container 
                                spacing={ 2 }
                                py={ 2 }
                                className='fadeIn'
                                display={ invoiceData.requiereFactura === 'Si' ? 'flex' : 'none' }
                            >
                                <Grid item xs={ 6 }>
                                    <TextField
                                        defaultValue={ '' }
                                        helperText=''
                                        fullWidth
                                        variant='standard'
                                        label='Factura a nombre de / Invoice to'
                                        name='aNombreDe'
                                        onChange={ handleInputChange }
                                    />
                                </Grid>
                                <Grid item xs={ 6 }>
                                    <TextField
                                        defaultValue={ '' }
                                        helperText=''
                                        fullWidth
                                        variant='standard'
                                        label='Correo electrónico / Email'
                                        name='correo'
                                        onChange={ handleInputChange }
                                    />
                                </Grid>
                                <Grid item xs={ 6 }>
                                    <SelectCustom 
                                        label='Tipo de factura / Invoice type'
                                        name='facturaTipo'
                                        options={ [
                                            { value: 'Nacional', label: 'Contribuyente Nacional' },
                                            { value: 'Extranjero', label: 'Para el Extranjero | Foreigner' },
                                        ] }
                                        parentCallback={ handleInputChange }
                                        // value={ isInvoiceRequired }
                                        variant='standard'
                                    />
                                </Grid>


                                {/* 
                                //* Si es Nacional
                                */}
                                <Grid item xs={ 12 } className='fadeIn'
                                display={ invoiceData.facturaTipo === 'Nacional' ? 'flex' : 'none' }
                                >
                                    <Grid container spacing={ 1 }>
                                        <Grid item xs={ 12 }>
                                            <FileUploadCustom 
                                                helperText='Anexar la Constancia de Situación Fiscal como PDF'
                                                //* Ejecuta 'handleFileUploaded' con el resultado del upload y el id del control
                                                parentCallback={ (e) => handleFileUploaded(e, 'constanciaURL') }
                                                //* Muestra el waiting dialog en lo se realiza el upload
                                                parentWaitingCallback={ (val) => setUploadingFile(val) }
                                                saveFileAs= { `${ referencia }_constanciaSituacionFiscal` }
                                                validTypes ={ ['pdf'] }
                                                variant='standard'
                                            />
                                        </Grid>
                                        <Grid item xs={ 6 }>
                                            <TextField
                                                defaultValue=''
                                                helperText=''
                                                fullWidth
                                                variant='standard'
                                                label='RFC'
                                                name='RFC'
                                                onChange={ handleInputChange }
                                            />
                                        </Grid>
                                        <Grid item xs={ 6 }>
                                            <TextField
                                                defaultValue=''
                                                helperText=''
                                                fullWidth
                                                variant='standard'
                                                label='CP'
                                                name='CP'
                                                onChange={ handleInputChange }
                                            />
                                        </Grid>
                                        <Grid item xs={ 12 }>
                                            <SelectCustom
                                                label='Uso CFDI'
                                                name='UsoCFDI'
                                                options={ dataCDFIs }
                                                parentCallback={ handleCatalogChange }
                                                variant='standard'
                                            />
                                        </Grid>
                                        <Grid item xs={ 12 }>
                                            <SelectCustom
                                                label='Regimen Fiscal'
                                                name='RegimenFiscal'
                                                options={ dataRFs }
                                                parentCallback={ handleCatalogChange }
                                                variant='standard'
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>



                                {/* 
                                //* Es Patrocinador
                                */}
                                <Grid 
                                    display={ record.tipoRegistro === 'Patrocinador' ? 'flex' : 'none' }
                                    flexDirection='column'
                                    item 
                                    xs={ 12 } 
                                >
                                    <TextField
                                        defaultValue={ '' }
                                        helperText='Datos por agregar como patrocinador / Info to add as sponsor'
                                        fullWidth
                                        variant='standard'
                                        label='Concepto | Concept'
                                        name='concepto'
                                        onChange={ handleInputChange }
                                    />
                                </Grid>
                                <Grid 
                                    display={ (record.tipoRegistro === 'Patrocinador' && invoiceData.facturaTipo === 'Nacional') ? 'flex' : 'none' }
                                    flexDirection='column'
                                    item 
                                    xs={ 12 } 
                                >
                                    <Divider sx={{ my: 1, color: 'white', borderColor: 'white' }} />
                                    <FileUploadCustom 
                                        helperText='Anexar formato 32D como PDF / Add 32D as PDF'
                                        //* Ejecuta 'handleFileUploaded' con el resultado del upload y el id del control
                                        parentCallback={ (e) => handleFileUploaded(e, 'formato32DURL') }
                                        //* Muestra el waiting dialog en lo se realiza el upload
                                        parentWaitingCallback={ (val) => setUploadingFile(val) }
                                        saveFileAs= { `${ referencia }_formato32DURL` }
                                        validTypes ={ ['pdf'] }
                                        variant='standard'
                                    />
                                </Grid>
                            </Grid>


                            {/* 
                            //* Boton continuar al pago 
                            */}
                            <Box 
                                className="fadeIn" 
                                mt={ 2 }
                                display='flex'
                                flexDirection='row'
                                justifyContent='flex-end'
                            >
                                <Button 
                                    color='primary' 
                                    className='circular-btn' 
                                    size='large'
                                    type='submit'
                                    variant='contained'
                                >
                                    Enviar
                                </Button>
                            </Box>
                        </Paper>
                    </form>
            </Container>
        }
        </ThemeProvider>
    )
}
